import { formatDistanceToNow } from 'date-fns';

export function asArray(data) {
  return Array.isArray(data) ? data : [];
}

export function safeFormatDistanceToNow(value, options) {
  if (!value) return '—';
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  try {
    return formatDistanceToNow(date, options);
  } catch {
    return '—';
  }
}
